import { event } from "./event"
//触发事件的方式1：鼠标事件种类
const pcMouseEventTypes = [
  {
    label: "鼠标点击时",
    value: "click"
  },
  {
    label: "鼠标双击时",
    value: "dblclick"
  },
  {
    label: "鼠标悬停时",
    value: "hover"
  },
  {
    label: "鼠标移入时",
    value: "mouseover"
  },
  {
    label: "鼠标移出时",
    value: "mouseout"
  },
  {
    label: "鼠标按下时",
    value: "mousedown"
  },
  {
    label: "鼠标松开时",
    value: "mouseup"
  }
]
const appMouseEventsTypes = [
  {
    label: "手指按下时",
    value: "touchstart"
  },
  {
    label: "手指抬起时",
    value: "touchend"
  }
]
//触发事件的方式2：数据事件种类
const dataEventTypes = [
  {
    label: "数据发生改变时",
    value: "anyDataChange"
  },
  {
    label: "变量发生改变时",
    value: "appointDataChange"
  }
]
export const allEventTypes = {
  get mouseEventsTypes() {
    return !window.location.href.includes("appHome") ? pcMouseEventTypes : appMouseEventsTypes
  },
  get dataEventsTypes() {
    return dataEventTypes
  }
}

//触发事件后的动作1：浏览器动作
export const windowMovement = [
  {
    label: "当前页面打开",
    value: "self"
  },
  {
    label: "新页面打开",
    value: "open"
  },
  {
    label: "滚动窗口",
    value: "scroll"
  },
  {
    label: "相对滚动",
    value: "scrollBy"
  }
]
//触发事件后的动作1：组件动作
export const componentMovement = [
  {
    label: "组件样式调整",
    value: "options"
  },
  {
    label: "组件显示隐藏",
    value: "show"
  }
]
//触发事件的事件类型
export const triggerTypes = {
  click: "mouse",
  hover: "mouse",
  dblclick: "mouse",
  mouseover: "mouse",
  mouseout: "mouse",
  mousedown: "mouse",
  mouseup: "mouse",
  touchstart: "mouse", //移动端事件
  touchend: "mouse", //移动端事件
  anyDataChange: "data",
  appointDataChange: "data"
}
////触发事件后的动作的类型表
export const moveMentTypes = {
  options: "component",
  show: "component",
  self: "window",
  open: "window",
  scroll: "window",
  scrollBy: "window"
}

export const optionType = [
  {
    label: "对比更新",
    value: "diff"
  },
  {
    label: "全量更新",
    value: "force"
  }
]
export const symbols = {
  "{": "&#123;",
  "}": "&#124;",
  "(": "&#40;",
  ")": "&#41;"
}
/**
 *
 * @param {String} str
 * 检查字符串是否符合要求，要求如下：
 * 1.字符串内的所有大括号{}已闭合，例如awqr{{ws((qweqw))ds}}qeqw
 */
export function checkStr(str) {
  if (!str.length) return true
  const symbolObj = {
    "{": "}",
    "}": "{",
    "(": ")",
    ")": "("
  }
  const arr = []
  for (let i = 0, last; i < str.length; i++) {
    const item = str[i]
    last = arr[arr.length - 1]
    if (item === "{") {
      arr.push("{")
    }
    if (item === "}") {
      if (arr.length === 0) return false
      if (symbolObj[last] === item) {
        arr.pop()
      } else return false
    }
    if (item === "(") {
      arr.push("(")
    }
    if (item === ")") {
      if (arr.length === 0) return false
      if (symbolObj[last] === item) arr.pop()
      else return false
    }
  }
  return arr.length === 0
}
export const echartsEventsInEvent = {
  click: ["eventControl.click"],
  dblclick: ["eventControl.dblclick"],
  mouseover: ["eventControl.mouseover"],
  mouseout: ["eventControl.mouseout"],
  mouseup: ["eventControl.mouseup"],
  mousedown: ["eventControl.mousedown"],
  touchstart: ["eventControl.touchstart"],
  touchend: ["eventControl.touchend"]
}
//找到事件总线中 数据当前组件的事件和当前组件的的子组件的事件
// 并过滤掉所有操作当前组件及其子组件之外的事件响应
export function getTarComponentEvent(ids, cb) {
  const filterIdsStr = event.getIdsByStrId(ids)
  let fuzzyEvents = null
  let allEventsInEvent = event.allEvents()
  if (allEventsInEvent) {
    //找到数据当前组件的所有 有事件响应的子组件事件
    Object.keys(allEventsInEvent).forEach(idsStr => {
      if (idsStr.includes(filterIdsStr)) {
        if (!fuzzyEvents) fuzzyEvents = {}
        fuzzyEvents[idsStr] = filterEvents(allEventsInEvent[idsStr], filterIdsStr, cb) //将返回的事件组中 外部组件事件过滤掉
      }
    })
  }
  return fuzzyEvents
}
function filterEvents(events, filterIdsStr, cb) {
  const tar = JSON.parse(JSON.stringify(events))
  const subEv = tar.events
  const { dataEvents, mouseEvents } = subEv
  //删除子组件事件中 修改当前组件之外的组件的事件
  filterEffect(dataEvents, filterIdsStr, cb)
  filterEffect(mouseEvents, filterIdsStr, cb)
  return tar
}
function filterEffect(tarEvents, filterIdsStr, cb) {
  if (tarEvents && typeof tarEvents === "object") {
    Object.keys(tarEvents).forEach(eventType => {
      const eventsByType = tarEvents[eventType]
      for (let i = 0; i < eventsByType.length; i++) {
        const movementDes = eventsByType[i]
        if (movementDes.ids) {
          const idsStr = event.getIdsByStrId(movementDes.ids)
          if (idsStr.includes(filterIdsStr) === false) {
            if(movementDes.from?.uid){
              /*
              *  自由布局列同步时，需要同步列的交互事件，并修改对应的列事件uid
              *  为了实现自由布局列的交互事件同步，实现点击列传参等需求
              * */
              cb && cb(movementDes)
            }else{
              eventsByType.splice(i--, 1)
            }
            continue
          }
        }
        cb && cb(movementDes)
      }
    })
  }
}
//把保存好的事件 经过处理后 将保存好的事件与当前id进行匹配并返回新事件对象
export function copyRectEvents(opt) {
  const { ids, options } = opt
  const { event: tarEvent, layoutUidMap } = options
  if (tarEvent) {
    delete options.event
  }
  if (layoutUidMap) {
    delete options.layoutUidMap
  }
  let res = {}
  tarEvent &&
    Object.keys(tarEvent).forEach(idsStr => {
      const newIds = event.getIdsByStrId({ ...ids }) + "-" + getStrFromRectId(idsStr)
      res[newIds] = updateIds({ ...ids }, tarEvent[idsStr])
      Object.assign(res[newIds].publishComponentIds, ids)
    })

  //有这个参数 说明是自由布局组件
  layoutUidMap &&
    Object.keys(layoutUidMap).forEach(uidK => {
      res = JSON.parse(JSON.stringify(res).replaceAll(uidK, layoutUidMap[uidK]))
    })

  return res
}
function updateIds(ids, event) {
  const { dataEvents, mouseEvents } = event.events
  fixIds(ids, dataEvents)
  fixIds(ids, mouseEvents)
  return event
}
function fixIds(newIds, tarEvents) {
  if (tarEvents && typeof tarEvents === "object") {
    Object.keys(tarEvents).forEach(eventType => {
      const eventsByType = tarEvents[eventType]
      for (let i = 0; i < eventsByType.length; i++) {
        const movementDes = eventsByType[i]
        if (movementDes.ids) {
          Object.assign(movementDes.ids, newIds)
        }
        if (movementDes.from) {
          Object.assign(movementDes.from, newIds)
        }
      }
    })
  }
}
function getStrFromRectId(idsStr) {
  const startStr = "rect_id_"
  const startIndex = idsStr.indexOf(startStr)
  const otherIdsStr = idsStr.slice(startIndex)
  return otherIdsStr.includes("-") ? otherIdsStr.slice(otherIdsStr.indexOf("-") + 1) : ""
}
export function copyColEvents({ from, to }) {
  const fromId = { container_id: from.container_id, rect_id: from.rect_id, uid: from.uid }
  const toId = { container_id: to.container_id, rect_id: to.rect_id, uid: to.uid }
  //返回过滤掉了当前id之外的事件的组件组
  const formateFromEvents = getTarComponentEvent(fromId, tarEvent => {
    if (tarEvent?.ids?.uid === fromId.uid) {
      tarEvent.ids.uid = toId.uid
    }
    if (tarEvent?.from?.uid === fromId.uid) {
      tarEvent.from.uid = toId.uid
    }
  })
  const res = {}
  //格式化数据，把新事件的id替换为新col的uid
  for (let k in formateFromEvents) {
    res[k.replace(fromId.uid, toId.uid)] = formateFromEvents[k]
  }
  event.deleteEventByDep(toId, "delColInLayout") //如果粘贴到的按个单元格有事件的话 就需要把相应的事件删除
  return res // 如果复制单元格有事件 就把这些事件格式化为粘贴组件的id格式
}
export function filterPcEvents(allEvents) {
  for (const idsStr in allEvents) {
    const tarEvent = allEvents[idsStr]
    const { mouseEvents } = tarEvent.events
    for (const eventName in mouseEvents) {
      if (eventName !== "mousedown" && eventName !== "mouseup") {
        //删除鼠标按下抬起之外的事件
        delete mouseEvents[eventName]
      } else {
        //将鼠标按下抬起换成手指按下抬起
        const mouseEvent = mouseEvents[eventName]
        const newMouseEventName = eventName === "mousedown" ? "touchend" : "touchstart"
        delete mouseEvents[eventName]
        mouseEvents[newMouseEventName] = mouseEvent
      }
    }
  }
  return allEvents
}
